var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultsFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 82,
    viewBox: "0 0 107 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 105,
    height: 80,
    rx: 6,
    fill: "#F9F7F4",
    stroke: "#ECEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.68629 3.68629 1 7 1H100C103.314 1 106 3.68629 106 7V12.6364H1V7Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0639 8.27237C9.85467 8.27237 10.4957 7.62115 10.4957 6.81783C10.4957 6.0145 9.85467 5.36328 9.0639 5.36328C8.27313 5.36328 7.63208 6.0145 7.63208 6.81783C7.63208 7.62115 8.27313 8.27237 9.0639 8.27237Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8366 8.27237C14.6274 8.27237 15.2684 7.62115 15.2684 6.81783C15.2684 6.0145 14.6274 5.36328 13.8366 5.36328C13.0458 5.36328 12.4048 6.0145 12.4048 6.81783C12.4048 7.62115 13.0458 8.27237 13.8366 8.27237Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6096 8.27237C19.4003 8.27237 20.0414 7.62115 20.0414 6.81783C20.0414 6.0145 19.4003 5.36328 18.6096 5.36328C17.8188 5.36328 17.1777 6.0145 17.1777 6.81783C17.1777 7.62115 17.8188 8.27237 18.6096 8.27237Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5853 61.6605L57.3308 55.4166C57.0181 55.1668 56.6428 54.9795 56.2675 54.9795H55.2668C56.9555 52.7941 58.0188 50.0468 58.0188 46.9873C58.0188 39.8693 52.1396 34 45.0094 34C37.8167 34 32 39.8693 32 46.9873C32 54.1678 37.8167 59.9746 45.0094 59.9746C48.0116 59.9746 50.7636 58.9756 53.0152 57.2273V58.2888C53.0152 58.6634 53.1403 59.038 53.453 59.3502L59.645 65.5317C60.2704 66.1561 61.2086 66.1561 61.7715 65.5317L63.5228 63.7834C64.1482 63.2215 64.1482 62.2849 63.5853 61.6605ZM45.0094 54.9795C40.5687 54.9795 37.0036 51.4205 37.0036 46.9873C37.0036 42.6166 40.5687 38.9951 45.0094 38.9951C49.3876 38.9951 53.0152 42.6166 53.0152 46.9873C53.0152 51.4205 49.3876 54.9795 45.0094 54.9795Z",
    fill: "#DDDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5512 36.7382C62.7184 35.7899 63.0664 35.0427 63.5952 34.4966C64.1422 33.9537 64.892 33.3807 65.8445 32.7777C66.5428 32.3367 67.0609 31.9579 67.3987 31.6414C67.7581 31.3099 67.9795 30.9071 68.0631 30.4329C68.1821 29.7581 68.0018 29.181 67.5222 28.7015C67.0641 28.2071 66.3882 27.8811 65.4946 27.7235C64.6375 27.5723 63.8393 27.6197 63.1002 27.8654C62.3826 28.0962 61.7396 28.4905 61.1711 29.0484L58.2035 26.5225C59.1753 25.4904 60.3648 24.7693 61.7722 24.3593C63.1979 23.9526 64.8043 23.9067 66.5915 24.2219C68.6888 24.5917 70.2878 25.3343 71.3886 26.4498C72.5077 27.5686 72.9273 28.9212 72.6475 30.5079C72.5157 31.2556 72.2723 31.8896 71.9173 32.41C71.5805 32.9335 71.1944 33.3637 70.7589 33.7006C70.3448 34.0225 69.8101 34.3889 69.1547 34.7999C68.3738 35.2827 67.7914 35.7066 67.4074 36.0713C67.0266 36.4179 66.7848 36.883 66.6819 37.4666L62.5512 36.7382ZM63.4195 43.9711C62.6718 43.8392 62.0844 43.4912 61.6574 42.927C61.2518 42.3478 61.1101 41.7117 61.2323 41.0187C61.3545 40.3256 61.702 39.7946 62.2748 39.4255C62.8508 39.0381 63.5218 38.912 64.2877 39.0471C65.0537 39.1821 65.6411 39.5301 66.0499 40.0911C66.4619 40.6339 66.6068 41.2518 66.4846 41.9448C66.3624 42.6378 66.0026 43.1855 65.4051 43.5878C64.8291 43.9752 64.1672 44.1029 63.4195 43.9711Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsFound);
export default __webpack_public_path__ + "static/media/no-results-found.e52197b8da4592048dd7e9417b5953dc.svg";
export { ForwardRef as ReactComponent };